import { render, staticRenderFns } from "./PrimaryResidence.vue?vue&type=template&id=9aa90d10&"
import script from "./PrimaryResidence.vue?vue&type=script&lang=js&"
export * from "./PrimaryResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports